import Vue from "vue";
import VueTelInput from "vue-tel-input";

const options = {
  dynamicPlaceholder: true,
  mode: "international",
  defaultCountry: "MX",
  inputOptions: {
    showDialCode: true,
  },
};

Vue.use(VueTelInput, options);
